import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Divider,
  Grid,
  IconButton,
  Typography,
  Button,
  // FormControl,
  // FormControlLabel,
  // Radio,
  // RadioGroup,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useInstance } from "easy-redux-http-call";
import { AI_getNotification } from "APIs/notification";
import { AI_getUserData } from "APIs/user";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import ContentPasteGoContainedIcon from "@mui/icons-material/ContentPasteGoOutlined";
import { AI_getPendingLeaveList, AI_acknowledgeLeave } from "APIs/leave";
import { store } from "store";
import { OPEN_LEAVE_MODEL } from "reducers/menu";
// import Button from "themes/overrides/Button";
import CommonButton from "components/common-component/Button";
import ShowLeaveDates from "pages/Emplyoee/Leave/ShowLeaveDates";
import { Chip, Tooltip } from "../../../node_modules/@mui/material/index";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import CommonToolTip from "components/common-component/Tooltip";
import CommonTexField from "components/common-component/textField";
import moment from "moment";
import { date } from "../../../node_modules/yup/lib/locale";

const useStyle = makeStyles((theme) => ({
  dialog: {
    position: "absolute",
    top: 50,
    minWidth: 500,
    width: "fit-content",
    maxWidth: "90vw",
    height: "450px",
    overflowX: "auto",
    [theme.breakpoints.between("xs", "sm")]: {
      width: "80%",
    },
  },
  noNotification: {
    textAlign: "center",
    padding: "40px 0px",
  },
  hrDialogTitle: {
    display: "flex",
    gap: "10px",
  },
  hrContainedIcon: {
    marginTop: "4px",
  },
  hrTitle: {
    textAlign: "left",
  },
  hrCloseIcon: {
    position: "absolute",
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  },
  hrNotification: {
    display: "flex",
    justifyContent: "space-between",
    margin: "10px 0px",
  },
  hrTitleName: {
    cursor: "pointer",
  },
  hrDob: {
    color: "gray",
  },
  hrLeaveDate: {
    whiteSpace: "pre-line",
  },
  hrLeaveTable: {
    display: "grid",
    "& > *": {
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      padding: "12px 6px",
      display: "flex",
      alignItems: "center",
    },
  },
  chip: {
    borderRadius: "27px",
    maxWidth: 200,
  },

  // Leave request details dailog styles
  dialogLeaveDetails: {
    [theme.breakpoints.down("md")]: {
      width: "80%",
    },
    width: "30%",
  },
  error: {
    marginTop: "-15px",
    color: "#ff4d4f",
    fontSize: "0.75rem",
    fontWeight: 400,
  },
  dateRangePicker: {
    "&>div": {
      width: "100%",
      "&>div": {
        width: "100%",
        "&>div": {
          width: "100%",
          margin: 0,
          padding: "10px",
        },
      },
    },
  },
  psAdvanceDateRangeSelector: {
    width: "90%",
    padding: "16px 10px",
    borderRadius: 4,
    border: `1px solid ${theme.palette.grey[300]}`,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    "&>p": {
      paddingRight: 10,
    },
    "&>svg": {
      width: 20,
      height: 20,
    },
  },
  dialogTitleLeaveDetails: {
    display: "flex",
    gap: "10px",
  },
  closeIconButtonLeaveDetails: {
    position: "absolute",
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  },
  dialogContentLeaveDetails: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    marginTop: "20px",
  },
  hrDialogTitleLeaveDetails: {
    textAlign: "left",
  },
  hrRadioLeaveLeaveDetails: {
    display: "grid",
  },
  radioAndTotalLeaveBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "18px",
  },
  cursorLeaveDetails: {
    cursor: "pointer",
  },
}));

const LeaveAckChip = ({ list = [], type }) => {
  const classes = useStyle();
  const concatedNames = list
    .map((ack) => `${ack?.employee?.first_name} ${ack?.employee?.last_name}`)
    .join(",");

  return (
    <CommonToolTip
      title={`${
        type == "success"
          ? "Approved By:"
          : type == "error"
          ? "Rejected By:"
          : "Not responsed yet:"
      }  ${concatedNames}`}
    >
      <Chip
        icon={
          type == "success" ? (
            <ThumbUpOffAltIcon />
          ) : type == "error" ? (
            <ThumbDownOffAltIcon />
          ) : (
            <HourglassEmptyIcon />
          )
        }
        className={classes.chip}
        label={concatedNames}
        color={type}
        variant="outlined"
      />
    </CommonToolTip>
  );
};

const LeaveHeading = ({ is_super_role, type }) => {
  return (
    <>
      <Typography style={{ fontWeight: 600 }}>Employee</Typography>
      <Typography style={{ fontWeight: 600 }}>  {type === "leave" ?  "Leave Dates"  : "Extra Dates" } </Typography>
      <Typography style={{ fontWeight: 600 }}> {type === "leave" ?  "Leave Reason"  : "Extra Day Reason" }  </Typography>
      <Typography style={{ fontWeight: 600 }}>Applied On</Typography>
      {is_super_role && (
        <Typography style={{ fontWeight: 600 }}>Acknowledged By</Typography>
      )}
      <Typography style={{ fontWeight: 600 }}>Action</Typography>
    </>
  );
};

const LeaveRow = ({ data, is_super_role }) => {
  const classes = useStyle();
  const [open, setOpen] = useState(false);
  // const navigate = useNavigate();

  // console.log(data.employee_id);

  const [openStatus, setOpenStatus] = useState(false);

  const handleOpenDialog = () => {
    setOpenStatus(true);
  };

  const handleCloseDialog = () => {
    setOpenStatus(false);
  };

  // TODO NEED TO CHECK THIS CODE
  let startDate = new Date(data.leave_date);
  let endDate = new Date(data.to_date);

  let timeDifference = endDate.getTime() - startDate.getTime();

  let numberOfDays = Math.floor(timeDifference / (1000 * 60 * 60 * 24)) + 1;

    let currentDay = new Date(startDate);  

    let numberOfDaysExcludeWeekends = 0; 
    for (let i = 0; i < numberOfDays; i++) {
      // Sunday is 0, Saturday is 6
      if (currentDay.getDay() !== 0 && currentDay.getDay() !== 6) {
        numberOfDaysExcludeWeekends++;
      }
      currentDay.setDate(currentDay.getDate() + 1);
    }

  // const appliedOndate = (date) => {
  //   const months = [
  //     "January",
  //     "February",
  //     "March",
  //     "April",
  //     "May",
  //     "June",
  //     "July",
  //     "August",
  //     "September",
  //     "October",
  //     "November",
  //     "December",
  //   ];
  //   const dateOfApplication = new Date(date);
  //   const day = dateOfApplication.getDate();
  //   const monthIndex = dateOfApplication.getMonth();
  //   const year = dateOfApplication.getFullYear();
  //   // Format the date as "17 January 2024"
  //   const formattedDate = `${day} ${months[monthIndex]} ${year}`;
  //   return formattedDate;
  // };
  return (
    <>
      <Typography
        onClick={handleOpenDialog}
        className={classes.cursorLeaveDetails}
      >
        {data?.employee?.first_name} {data?.employee?.last_name}
      </Typography>

      {/* Leave Request Details dailog */}
      <Dialog
        open={openStatus}
        classes={{ paper: classes.dialogLeaveDetails }}
        fullWidth
      >
        <DialogTitle>
          <div className={classes.dialogTitleLeaveDetails}>
            <ContentPasteGoContainedIcon width={24} height={24} />
            <Typography
              variant="h4"
              className={classes.hrDialogTitleLeaveDetails}
            >
              Leave Request Details
            </Typography>
          </div>
          <IconButton
            aria-label="close"
            onClick={() => handleCloseDialog()}
            className={classes.closeIconButtonLeaveDetails}
            color="error"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />

        <Grid className={classes.dialogContentLeaveDetails}>
          <div className={classes.psAdvanceDateRangeSelector}>
            <Typography>
              Start Date : {`${moment(data?.leave_date).format("DD-MM-YY")}`}
              <Typography variant="title" color="inherit" noWrap>
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              </Typography>
              To Date : {`${moment(data?.to_date).format("DD-MM-YY")}`}
            </Typography>
          </div>
        </Grid>
        <div className={classes.radioAndTotalLeaveBox}>
          {/* Dont delete below code */}
          {/* <Grid>
              <FormControl className={classes.hrRadioLeaveLeaveDetails} >
                <RadioGroup
                  row
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="leave"
                  value="leave"
                >
                  <FormControlLabel
                    value="leave"
                    label="Leave"
                    control={<Radio value="leave" />}
                  />
                </RadioGroup>
              </FormControl>
          </Grid> */}
          <Grid className={classes.hrRadioLeaveLeaveDetails}>
            {data.type === "leave" ? (
              <>
                <p>Total Full-day Leaves: {data?.total_FullDay_Leaves}</p>
                <p>Total Half-day Leaves: {data?.total_HalfDay_Leaves}</p>
              </>
            ) : (
              <>
                <p>Total Extra Full-day Leaves: {data?.total_Extra_FullDay}</p>
                <p>Total Extra Half-day Leaves: {data?.total_Extra_HalfDay}</p>
              </>
            )}
          </Grid>
        </div>
        <DialogContent>
          <Grid className={classes.dialogContent}>
            <CommonTexField
              className={classes.textField}
              required
              value={data?.reason}
              name="reason"
              label="Reason"
              placeholder="Reason"
            />
            <CommonTexField
              className={classes.textField}
              value={data?.description}
              name="description"
              label="Leave Description"
              placeholder="Leave Description"
              multiline
              rows={5}
            />
          </Grid>
        </DialogContent>
        <DialogActions>
          <>
            <Button variant="outlined" onClick={() => handleCloseDialog()}>
              Cancel
            </Button>
          </>
        </DialogActions>
      </Dialog>

      <Typography className={classes.hrLeaveDate}>
        {data?.leave_date && (
          <>
            {data?.leave_date === data?.to_date
              ? `For ${moment(data?.leave_date).format("DD MMMM yyyy")}`
              : `From ${moment(data?.leave_date).format("DD MMMM yyyy")}
               to ${moment(data?.to_date).format("DD MMMM yyyy")}`}&nbsp;
               {data?.is_sandwich == "1" && (
                  <Chip
                    label="Sandwich"
                    color="error"
                    size="small"
                    className={classes.chip}
                  />
                )}
          </>
        )}
      </Typography>
      <Typography>{data.reason}</Typography>

      <Typography>
        {moment(data.createdAt).format("DD MMMM yyyy")}
        {/* {appliedOndate(data.createdAt)} */}
      </Typography>

      {is_super_role ? (
        <>
          <div
            style={{
              flexWrap: "wrap",
              gap: 4,
              alignItems: "start",
            }}
          >
            {data?.leave_acks?.filter((a) => a.acknowledged)?.length > 0 && (
              <LeaveAckChip
                list={data?.leave_acks?.filter((a) => a.acknowledged)}
                type="success"
              />
            )}
            {data?.leave_acks?.filter((a) => a.acknowledged === false)?.length >
              0 && (
              <LeaveAckChip
                list={data?.leave_acks?.filter((a) => a.acknowledged === false)}
                type="error"
              />
            )}
            {data?.leave_acks?.filter((a) => a.acknowledged === null)?.length >
              0 && (
              <LeaveAckChip
                list={data?.leave_acks?.filter((a) => a.acknowledged === null)}
                type="default"
              />
            )}
          </div>

          <div>
            <CommonButton onClick={() => setOpen(true)}>Approve</CommonButton>
          </div>
        </>
      ) : (
        <>
          {data?.leave_acks?.map((ack) => {
            if (ack?.acknowledged === null) {
              return (
                <div style={{ gap: 4 }}>
                  <Chip
                    className={classes.chip}
                    label={"Approve"}
                    color={"success"}
                    variant="contained"
                    onClick={() => {
                      AI_acknowledgeLeave.call({
                        urlParams: {
                          id: ack.id,
                        },
                        params: {
                          status: true,
                        },
                      });
                    }}
                  />
                  <Chip
                    className={classes.chip}
                    label={"Reject"}
                    color={"error"}
                    variant="contained"
                    onClick={() => {
                      AI_acknowledgeLeave.call({
                        urlParams: {
                          id: ack.id,
                        },
                        params: {
                          status: false,
                        },
                      });
                    }}
                  />
                </div>
              );
            } else {
              return (
                <div>
                  <Chip
                    className={classes.chip}
                    label={ack?.acknowledged == true ? "Approved" : "Rejected"}
                    color={ack?.acknowledged == true ? "success" : "error"}
                    variant="outlined"
                    onClick={() => {
                      AI_acknowledgeLeave.call({
                        urlParams: {
                          id: ack.id,
                        },
                        params: {
                          status: null,
                        },
                      });
                    }}
                  />
                </div>
              );
            }
          })}
        </>
      )}
      {open && (
        <ShowLeaveDates
          openStatus={open}
          type={data.type}
          handleClose={() => setOpen(false)}
          leaveId={data.id}
          approverView
        />
      )}
    </>
  );
};

const LeaveDashBoard = ({ openStatus, handleCloseAction = () => {}, type }) => {
  const classes = useStyle();
  const notificationReduxState = useInstance(AI_getNotification);
  const [notificationData, setNotificationData] = useState([]);
  const getUserData = useInstance(AI_getUserData);
  const navigate = useNavigate();
  useEffect(() => {
    const notificationOtherData =
      notificationReduxState?.data?.all_notification?.rows?.filter((data) => {
        return data.type === "leave";
      });

    setNotificationData(notificationOtherData);
  }, [notificationReduxState]);
  const handleRedirect = (data, type) => {
    navigate(`employee/${data.employee_id}/details`);
    localStorage.setItem("employee-view", "Leave / Extra-day");
    localStorage.setItem("activeMenuItem", "emplyoee-details");
    store.dispatch({
      type: OPEN_LEAVE_MODEL,
      payload: { open: true, id: data.id },
    });
  };

  const pendingLeaveRequest = useInstance(AI_getPendingLeaveList);
  useEffect(() => {
    if (
      !pendingLeaveRequest?.data?.rows
      // &&
      // getUserData?.data?.user?.is_access_to_employee
    ) {
      AI_getPendingLeaveList.call();
    }
  }, [openStatus]);

  useEffect(() => {
    if (type === "leave") {
      const temp = pendingLeaveRequest?.data?.rows.filter(
        (data) => data.type === "leave"
      );
      setNotificationData(temp);
    } else {
      const temp = pendingLeaveRequest?.data?.rows.filter(
        (data) => data.type === "extra"
      );
      setNotificationData(temp);
    }
  }, [openStatus, pendingLeaveRequest]);

  return (
    <Dialog
      open={openStatus}
      classes={{ paper: classes.dialog }}
      onClick={(event) => event.stopPropagation()}
      fullWidth
    >
      <DialogTitle>
        <div className={classes.hrDialogTitle}>
          <ContentPasteGoContainedIcon className={classes.hrContainedIcon} />
          <Typography variant="h4" className={classes.hrTitle}>
            {type === "leave"
              ? "Pending Leave Requests"
              : "Pending Extra-day Requests"}
          </Typography>
        </div>
        <IconButton
          aria-label="close"
          onClick={() => handleCloseAction()}
          className={classes.hrCloseIcon}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Grid>
          {notificationData?.length === 0 && (
            <Grid className={classes.noNotification}>
              <Typography variant="h4">No More Pending Request</Typography>
            </Grid>
          )}
          {notificationData?.length !== 0 && (
            <>
              {type == "leave" || type == "extra" ? (
                <>
                  <div
                    className={classes.hrLeaveTable}
                    style={{
                      gridTemplateColumns: getUserData?.data?.user
                        ?.is_super_role
                        ? "0.75fr 1fr 1fr 1fr 2fr 0.5fr"
                        : "0.75fr 1fr 1fr 1fr 0.5fr",
                    }}
                  >
                    <LeaveHeading
                      is_super_role={getUserData?.data?.user?.is_super_role}
                      type={type}
                    />
                    {notificationData?.map((data) => (
                      <LeaveRow
                        key={data.id}
                        data={data}
                        is_super_role={getUserData?.data?.user?.is_super_role}
                        />
                    ))}
                  </div>
                </>
              ) : (
                <>
                  {notificationData?.map((data) => (
                    <div key={data.id}>
                      <Grid className={classes.hrNotification}>
                        <Typography
                          onClick={() => handleRedirect(data)}
                          className={classes.hrTitleName}
                        >
                          {data?.employee?.first_name}{" "}
                          {data?.employee?.last_name}
                        </Typography>
                        <Typography variant="p" className={classes.hrDob}>
                          {moment(data.createdAt).format("DD MMMM yyyy")}
                        </Typography>
                      </Grid>
                      <Divider />
                    </div>
                  ))}
                </>
              )}
            </>
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default LeaveDashBoard;
